import { Navigate, useLocation } from 'react-router-dom';

export function ProtectedRoute({ children, adminOnly = false }) {
  const location = useLocation();
  const token = localStorage.getItem('accessToken');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If adminOnly is required, check role
  if (adminOnly && user.role !== 'admin' && user.role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, render children
  return children;
}
